/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagduplicatename3Inputs */

const en_signupsflagduplicatename3 = /** @type {(inputs: Signupsflagduplicatename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate name`)
};

const de_signupsflagduplicatename3 = /** @type {(inputs: Signupsflagduplicatename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelter Name`)
};

/**
* | output |
* | --- |
* | "Duplicate name" |
*
* @param {Signupsflagduplicatename3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagduplicatename3 = /** @type {((inputs?: Signupsflagduplicatename3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagduplicatename3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagduplicatename3(inputs)
	return de_signupsflagduplicatename3(inputs)
});
export { signupsflagduplicatename3 as "signupsFlagDuplicateName" }